module.exports = __webpack_public_path__ + "img/bg_main04_mask_m.6ed7ae22.svg";